<template>
  <v-dialog v-model="dialog" max-width="600px" :key="wishlistKey">
    <v-card v-if="item">
      <form @submit.prevent="onSubmit">
        <v-card-title class="d-flex flex-column align-start pb-0">
          <p class="headline mb-1" style="width: 100%">
            {{ mess["dialog_wishlist_title"] }}
          </p>
        </v-card-title>
        <v-card-text>
          <v-container class="pt-0">
            <v-row>
              <v-col class="pa-0 pb-4">
                <div style="line-height: 1">
                  <span class="wishlist-label">{{ mess["sales_draw_modal_name"] || 'Наименование' }}:</span>
                  <a
                    v-if="item"
                    :href="item.href"
                    target="_blank"
                    class="wishlist-article mb-0"
                  >
                    {{ item.name }}
                  </a>
                </div>
                <div style="line-height: 1">
                  <span class="wishlist-label">{{ mess["sales_draw_modal_article"] || 'Артикул' }}:</span>
                  <span class="wishlist-article">
                    {{ item.code || item.article }}
                  </span>
                </div>
                <div style="line-height: 1">
                  <span class="wishlist-label">{{ mess["sales_draw_modal_oem"] || 'OEM' }}:</span>
                  <span class="wishlist-article">
                    {{ item.oem }}
                  </span>
                </div>
              </v-col>
            </v-row>
            <v-row class="mb-6">
              <v-col class="pa-0">
                <v-tabs
                  v-model="tab"
                  class="wishlist-steps"
                  background-color="transparent"
                  color="primary"
                  :show-arrows="false"
                  hide-slider
                >
                  <v-tab v-if="hasWishlists">
                    {{ mess["dialog_wishlist_tab_add_to_list"] }}
                  </v-tab>
                  <v-tab>
                    {{ mess["dialog_wishlist_tab_create_new_list"] }}
                  </v-tab>
                </v-tabs>
              </v-col>
            </v-row>
            <v-tabs-items v-model="tab">
              <v-tab-item v-if="hasWishlists">
                <v-row>
                  <v-col cols="12" class="pa-0">
                    <v-autocomplete
                      v-model="company"
                      v-validate="required['company']"
                      :items="companies"
                      outlined
                      dense
                      :label="mess['dialog_base_field_company']"
                      :error-messages="errors.collect('company')"
                      data-vv-name="company"
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="pa-0">
                    <v-autocomplete
                      v-model="wishlist"
                      v-validate="required['wishlist']"
                      :items="filteredWishlist"
                      outlined
                      dense
                      :label="mess['dialog_wishlist_field_wishlist']"
                      :error-messages="errors.collect('wishlist')"
                      data-vv-name="wishlist"
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item>
                <v-card flat>
                  <v-row>
                    <v-col cols="12" class="pa-0">
                      <v-autocomplete
                        v-model="companyNewWL"
                        v-validate="required['companyNewWL']"
                        :items="allCompanies"
                        outlined
                        dense
                        :label="mess['dialog_base_field_company']"
                        :error-messages="errors.collect('companyNewWL')"
                        data-vv-name="companyNewWL"
                      >
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" class="pa-0">
                      <v-text-field
                        v-model="wishlistTitle"
                        v-validate="required['wishlistTitle']"
                        outlined
                        dense
                        :label="mess['dialog_wishlist_field_wishlist_title']"
                        :error-messages="errors.collect('wishlistTitle')"
                        data-vv-name="wishlistTitle"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" class="pa-0">
                      <v-textarea
                        v-model="wishlistDescription"
                        outlined
                        dense
                        :label="
                          mess['dialog_wishlist_field_wishlist_description']
                        "
                      >
                      </v-textarea>
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-container>
          <small>{{ mess["dialog_base_required_label"] }}</small>
        </v-card-text>
        <v-card-actions style="padding: 0 24px 16px">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="elevation-0"
            dark
            outlined
            @click="dialog = false"
          >
            {{ mess["dialog_base_button_close"] }}
          </v-btn>
          <v-btn
            type="submit"
            color="primary"
            class="elevation-0"
            :loading="loading"
            dark
          >
            {{ mess["dialog_base_button_add"] }}
          </v-btn>
        </v-card-actions>
      </form>
      <v-btn absolute top right text icon @click="dialog = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card>
  </v-dialog>
</template>

<script>
import { wishlistService } from "@/services/wishlist-service/wishlist-service";

import sortBy from "lodash/sortBy";
import isEmpty from "lodash/isEmpty";

import notifications from "@/models/notificationTemplates";

export default {
  $_veeValidate: {
    validator: "new"
  },
  name: "WishlistDialog",
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => ({})
    },
    wishlistData: {
      type: Array,
      default: () => []
    }
  },
  data: function() {
    return {
      dialog: false,
      loading: false,
      tab: null,
      wishlist: null,
      company: null,
      companyNewWL: null,
      wishlistTitle: "",
      wishlistDescription: "",
      wishlistKey: "initial",
      dictionary: {
        custom: {
          company: {
            required: () => this.mess["dialog_base_required_error"]
          },
          companyNewWL: {
            required: () => this.mess["dialog_base_required_error"]
          },
          wishlist: {
            required: () => this.mess["dialog_base_required_error"]
          },
          wishlistTitle: {
            required: () => this.mess["dialog_base_required_error"]
          }
        }
      }
    };
  },
  computed: {
    errors() {
      return {};
    },
    hasWishlists() {
      return !isEmpty(this.wishlistData);
    },
    required() {
      if (this.hasWishlists && this.tab === 0)
        return { company: "required", wishlist: "required" };
      if ((this.hasWishlists && this.tab === 1) || !this.hasWishlists)
        return { companyNewWL: "required", wishlistTitle: "required" };
      return [];
    },
    companies() {
      if (!this.wishlistData) return [];
      return sortBy(
        this.wishlistData.map(wishlist => ({
          text: wishlist.companyName,
          value: wishlist.companyId
        })),
        ["text"]
      );
    },
    allCompanies() {
      if (!this.wishlistData) return [];
      return sortBy(
        this.$store.getters.allCompanies.map(company => ({
          text: company.title,
          value: company.id
        })),
        ["text"]
      );
    },
    filteredWishlist() {
      if (!this.company) return [];
      const currentWishlists = this.wishlistData.filter(
        wishlist => wishlist.companyId === this.company
      );
      return sortBy(
        currentWishlists.map(wishlist => ({
          text: wishlist.wishListName,
          value: wishlist.wishListId
        })),
        "text"
      );
    }
  },
  watch: {
    companies(val) {
      if (val && val.length) this.company = val[0].value;
    },
    allCompanies(val) {
      if (val && val.length) this.companyNewWL = val[0].value;
    },
    company() {
      this.wishlist = this.filteredWishlist[0].value;
    },
    isVisible(val) {
      this.dialog = val;
    },
    dialog(val) {
      this.$emit("update:is-visible", val);
    },
    tab() {
      this.$validator.reset();
    }
  },
  mounted() {
    this.$validator.localize("ru", this.dictionary);
  },
  methods: {
    resetWishlistDialog() {
      this.company = this.companies[0].value;
      this.wishlistTitle = "";
      this.wishlistDescription = "";
      this.$validator.reset();
      this.wishlistKey = "updated";
      this.tab = 0;
    },
    onSubmit() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true;

          // Добавление артикула в wishlist с созданием нового wishlist
          if (!this.hasWishlists || this.tab === 1) {
            return wishlistService
              .addWishlist({
                companyId: this.companyNewWL,
                title: this.wishlistTitle,
                description: this.wishlistDescription
              })
              .then(wishlist => {
                this.$emit("update-wishlist", {
                  wishListId: wishlist.id,
                  wishListName: wishlist.title,
                  companyId: this.companyNewWL,
                  companyName: this.allCompanies.find(
                    company => company.value === this.companyNewWL
                  ).text
                });
                return wishlistService.addItemToWishlist({
                  itemId: this.item.productId || this.item.id,
                  companyId: this.companyNewWL,
                  wishlistId: wishlist.id
                });
              })
              .then(() => {
                this.dialog = false;
                this.resetWishlistDialog();
                this.$emit(
                  "added-to-wishlist",
                  notifications.success.addToWishlist
                );
              })
              .catch(() => {
                this.$emit("added-to-wishlist", notifications.error.base);
              })
              .finally(() => (this.loading = false));
          }

          // Добавление артикула в wishlist
          return wishlistService
            .addItemToWishlist({
              itemId: this.item.productId || this.item.id,
              companyId: this.company,
              wishlistId: this.wishlist
            })
            .then(() => {
              this.dialog = false;
              this.resetWishlistDialog();
              this.$emit(
                "added-to-wishlist",
                notifications.success.addToWishlist
              );
            })
            .catch(() => {
              this.$emit("added-to-wishlist", notifications.error.base);
            })
            .finally(() => (this.loading = false));
        }
      });
    }
  }
};
</script>

<style lang="scss">
.v-text-field--outlined.v-input--is-focused fieldset,
.v-text-field--outlined.v-input--has-state fieldset {
  border-width: 1px !important;
}
.wishlist-steps {
  &.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) {
    border-bottom: none !important;
  }

  .v-tab.tab-active {
    background: rgba(234, 84, 50, 0.1);
    color: #ea5432 !important;
  }

  .v-tab--active.v-tab:not(:focus)::before {
    opacity: 0.12;
  }

  .v-slide-group__next,
  .v-slide-group__prev {
    display: none;
  }
}

a.wishlist-article {
  text-transform: uppercase;
  color: #1a1a1a !important;
  text-decoration: none;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.3;
  transition: color 200ms;

  &:hover {
    color: var(--v-primary-base) !important;
  }
}

span.wishlist-article {
  text-transform: uppercase;
  color: #1a1a1a !important;
  text-decoration: none;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.3;
  transition: color 200ms;
}

span.wishlist-label {
  padding-right: 2px;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.54) !important;
  text-decoration: none;
  font-size: 8px;
  font-weight: 600;
  line-height: 1.3;
  transition: color 200ms;
}
</style>
